import get from 'lodash/get';

import { checkRules, evaluateStage } from 'app/modules/configuration';
import { USER_AUTH } from 'app/modules/user/constants';
import { appInitialized } from 'app/modules/app';

export const authUser = record => ({ type: USER_AUTH, record });

const checkAuth = () => {
  return (dispatch, getState) => {
    let state = getState();
    let user = state.user;
    let id = get(user, 'id');

    // if an id exist, that means that the user have been authenticated in the past and
    // should be reauthenticated
    if (id) {
      dispatch(authUser(user));
      return;
    }

    dispatch(appInitialized());
    dispatch(checkRules());
    dispatch(evaluateStage());
  };
};

export default checkAuth;
